import { clone } from 'lodash';
import { createSelector } from 'reselect';
import { raw } from './selectors.raw';

export const $context = createSelector(raw.$rawRealtimeState, (realtimeState) => {
  const { tileArea } = realtimeState;

  return clone({
    tileArea,
  });
});
